
















import { Component, Vue, Prop } from "vue-property-decorator";

import PlantBackground from "@/components/PlantBackground.vue";

@Component({
  components: { PlantBackground },
})
export default class NotFoundView extends Vue {}
